import { render, staticRenderFns } from "./NavDrawer.vue?vue&type=template&id=48049aba&scoped=true&"
import script from "./NavDrawer.vue?vue&type=script&lang=js&"
export * from "./NavDrawer.vue?vue&type=script&lang=js&"
import style0 from "./NavDrawer.vue?vue&type=style&index=0&id=48049aba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48049aba",
  null
  
)

export default component.exports